import React from 'react';
import { ToolsBar, NavigationBar, SideMenu } from './';
import { useMenuNavigation } from '@/hooks/mainMenu';
import { useUI } from '@/hooks/ui';
import { colors, zIndex } from '@/assets/styles';
import { useAuth } from '@/api';


const TopNavigation: React.FC = () => {
  const {
    activeMenuItem,
    isConfigMenuOpen,
    isMobileMenuOpen,
    isUserMenuOpen,
    isHelpMenuOpen,
    isAppLauncherOpen,
    searchTerm,
    setIsMobileMenuOpen,
    setIsUserMenuOpen,
    setIsHelpMenuOpen,
    setIsAppLauncherOpen,
    handleMenuItemEnter,
    handleMenuItemLeave,
    handleConfigMenuEnter,
    handleConfigMenuLeave,
    clearMenuTimer,
    clearConfigTimer,
    handleLogout,
    handleUserMenuClose,
    handleAppLauncherClose,
    handleMobileMenuToggle,
    handleSearchChange,
    navigate,
  } = useMenuNavigation();
  const { openSidePanel } = useUI();
  const { user, rexSystems, isSSO } = useAuth();
  const displayName = user ? `${user.nombres} ${user.apellidoPaterno}`.trim() : undefined;


  const companyName = user?.companyName;

  const handleIncidentPanelOpen = () => {
    openSidePanel({
      title: 'Registrar Incidencia',
      component: 'RegisterIncidentForm',
      props: {},
    });
  };

  return (
    <>
      <div 
        className="fixed top-0 left-0 right-0"
        style={{ 
          backgroundColor: colors.primary.main,
          zIndex: zIndex.navbar, 
          boxShadow: '0px 1px 4px 0px #00000026',
        }}
        data-testid="top-navigation"
      >
        <ToolsBar
          isUserMenuOpen={isUserMenuOpen}
          isHelpMenuOpen={isHelpMenuOpen}
          isAppLauncherOpen={isAppLauncherOpen}
          searchTerm={searchTerm}
          setIsUserMenuOpen={setIsUserMenuOpen}
          setIsHelpMenuOpen={setIsHelpMenuOpen}
          setIsAppLauncherOpen={setIsAppLauncherOpen}
          handleMobileMenuToggle={handleMobileMenuToggle}
          handleSearchChange={handleSearchChange}
          handleUserMenuClose={handleUserMenuClose}
          handleAppLauncherClose={handleAppLauncherClose}
          handleLogout={handleLogout}
          handleIncidentPanelOpen={handleIncidentPanelOpen}
          navigate={navigate}
          userName={displayName}
          companyName={companyName}
          isSSO={isSSO}
          rexSystems={rexSystems}
        />

        <NavigationBar
          activeMenuItem={activeMenuItem}
          isConfigMenuOpen={isConfigMenuOpen}
          handleMenuItemEnter={handleMenuItemEnter}
          handleMenuItemLeave={handleMenuItemLeave}
          handleConfigMenuEnter={handleConfigMenuEnter}
          handleConfigMenuLeave={handleConfigMenuLeave}
          clearMenuTimer={clearMenuTimer}
          clearConfigTimer={clearConfigTimer}
        />

        <SideMenu
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
        />

        {!isMobileMenuOpen && (activeMenuItem || isConfigMenuOpen) && (
          <div 
            style={{
              position: 'fixed',
              top: 'var(--total-nav-height)',
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: colors.grays.overlayBackdrop,
              zIndex: zIndex.menuContentOverlay,
            }}
            data-testid="mega-menu-content-overlay" 
          />
        )}

        {isUserMenuOpen && (
          <div 
            className="fixed inset-0" 
            style={{ zIndex: zIndex.menuClickAwayOverlay }}
            onClick={handleUserMenuClose}
            data-testid="user-menu-click-away-overlay"
          />
        )}

        {isHelpMenuOpen && (
          <div 
            className="fixed inset-0" 
            style={{ zIndex: zIndex.menuClickAwayOverlay }}
            onClick={() => setIsHelpMenuOpen(false)}
            data-testid="help-menu-click-away-overlay"
          />
        )}

        {isAppLauncherOpen && (
          <div 
            className="fixed inset-0" 
            style={{ zIndex: zIndex.menuClickAwayOverlay }}
            onClick={handleAppLauncherClose}
            data-testid="app-launcher-click-away-overlay"
          />
        )}
      </div>
    </>
  );
};

export default TopNavigation;
